export default "__VITE_ASSET__Cc7xqZfU__"